let timelineElementsEd = [
    {
      id: 1,
      title: "Honors Bachelor of Technology – Software Development",
      location: "Toronto, Canada",
      description:
        "Seneca College, Toronto, ON",
      buttonText: "View Portfolio",
      date: "September 2018 – Present",
      icon: "school"
    },
    {
      id: 2,
      title: "Diploma – Full Stack Development",
      location: "Rivne, Ukraine",
      description:
        "Step Academy, Ukraine",
      buttonText: "View Portfolio",
      date: "September 2016 – September 2017",
      icon: "school"
    }    
  ];
  
  export default timelineElementsEd;
  